import { useState, useCallback } from "react";
import axios from "axios";

// Hook to manage SQL queries
export const useSqlQuery = () => {
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    
    // Execute the SQL query
    const executeQuery = useCallback(async () => {
        if (!query.trim()) return;
        
        try {
            setLoading(true);
            setError(null);
            setResult(null);
            
            const response = await axios.post("/query", query, {
                headers: {
                    "Content-Type": "text/plain",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`
                }
            });
            
            setResult(response.data);
        } catch (error) {
            setError(error.response?.data || {
                isSuccess: false,
                message: "Failed to execute query",
                errors: { query: ["An unknown error occurred"] }
            });
        } finally {
            setLoading(false);
        }
    }, [query]);
    
    return {
        query,
        setQuery,
        loading,
        result,
        error,
        executeQuery
    };
};